"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Price = void 0;
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Price = ({
  price
}) => {
  const {
    currentFormatted,
    oldFormatted
  } = price;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledPrice, {
    fontWeight: "bold",
    oldPriceVisible: Boolean(oldFormatted),
    children: currentFormatted
  });
};
exports.Price = Price;
